import { POST_TYPE_META, type PostType } from "@/hooks/use-post-generation";

type Translate = (key: string, opts?: Record<string, unknown>) => string;

/**
 * "Instagram Story", "YouTube Short", or just "TikTok" when the post uses the
 * platform's default format. `t` must be the "calendar" namespace translator,
 * which holds the platform names.
 */
export function postFormatLabel(platform: string, postType: string | null | undefined, t: Translate): string {
  const name = t(`platform.${platform}`, {
    defaultValue: platform.charAt(0) + platform.slice(1).toLowerCase(),
  });
  const meta = postType ? POST_TYPE_META[postType as PostType] : undefined;
  return meta ? `${name} ${meta.label}` : name;
}
